'use strict';
angular.module('cvsApp').factory('accountBalanceModel',['commonModel',function(CM) {	
	
	var acBalModel = function(){

		var self = this;

		self.apiResponse = {};
		
		this.setResponse = function(data){
			CM.setJSONResponse(data);		
		}	

		this.getResponse = function(data){
			self.apiResponse = CM.getResponse();
			self.header = CM.getHeader();		
			return self;		
		}	

		this.showView = function(){
			if(self.apiResponse.isViewError){	
				return !self.apiResponse.isViewError;
			}
			return true;
		}

		this.getError = function(){
			if(self.apiResponse.showError){	
				return self.apiResponse.showError;
			}
			return "";
		}
		
		this.getHeader = function () {
            return self.header;
        }

		
		this.getAcBal = function(){
			if(!self.apiResponse.showError && this.apiResponse.accountBalance){
				var abal;
				if(typeof(this.apiResponse.accountBalance) == 'string'){
					abal = this.apiResponse.accountBalance;
				} else {
					if(this.apiResponse.accountBalance.__text){
						abal = this.apiResponse.accountBalance.__text.replace(/[\n\r\t]+/g,'');
					}
				}

				abal = abal.replace('$','');

				if((abal > 0 && abal < 3) || (abal > -0.99 && abal < -0.01) ){
					abal = 0;
				}

				return abal;
			}	
				
		}

		this.isPaymentPending = function(){
			if(!self.apiResponse.showError && this.apiResponse.payments && this.apiResponse.payments.payment && this.apiResponse.payments.payment.recentPaymentIndicator &&
				this.apiResponse.payments.payment.recentPaymentIndicator===true && wcmContent.specialty_help.allow_multiple_payments && wcmContent.specialty_help.allow_multiple_payments !== "Y"){
					return true;
			}else{
				return false;
			}
		}

		this.isACHAuthorizationRequired = function(){
			if(!self.apiResponse.showError && this.apiResponse.payments  && this.apiResponse.payments.payment && this.apiResponse.payments.payment.achAuthRequiredInd &&
				this.apiResponse.payments.payment.achAuthRequiredInd=='true'){
				return true;
			}else{
				return false;
			}
		}

		this.recentPaymentAmount = function(){
			if(!self.apiResponse.showError && this.apiResponse.payments && this.apiResponse.payments.recentPaymentAmount){
				var abal;
				if(typeof(this.apiResponse.payments.recentPaymentAmount) == 'string'){
					abal = this.apiResponse.payments.recentPaymentAmount;
				} else {
					if(this.apiResponse.payments.recentPaymentAmount.__text){
						abal = this.apiResponse.payments.recentPaymentAmount.__text.replace(/[\n\r\t]+/g,'');
					}
				}

				abal = abal.replace('$','');
				return abal;
			}else{
				return "0.00"
			}

		}
	
	}
	
	return new acBalModel();
}]);